import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const BridgeShowTopBar = ({ backTo, backLabel, crumb }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<ArrowBackIcon />}
      component={Link}
      to={backTo}
      sx={{ borderColor: 'divider', textTransform: 'none' }}
    >
      {backLabel}
    </Button>
    <Typography color="text.secondary">{crumb}</Typography>
  </Box>
);
